import { QUERY_KEYS } from "@/common/query-keys";
import { fetchConsumablesPage } from "@/lib/snipeit/consumables";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

export interface ConsumablesPageParams {
  limit: number;
  offset: number;
  sort: string;
  order: "asc" | "desc";
  search?: string;
}

/**
 * Fetches a single page of consumables with server-side search, sorting and pagination.
 */
export function useConsumablesPage(params: ConsumablesPageParams) {
  const { limit, offset, sort, order, search } = params;

  return useQuery({
    queryKey: [QUERY_KEYS.consumablesPage, limit, offset, sort, order, search ?? ""],
    queryFn: () =>
      fetchConsumablesPage({
        limit,
        offset,
        sort,
        order,
        search: search || undefined,
      }),
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
}
